import React, { useContext, useState } from "react";
import {
    Table,
    EllipsisDropdown,
    ControlledPopup,
    VoicemailPlayback
} from "dyl-components";
import {
    DropdownItem,
    Dropdown,
    Icon,
    Checkbox,
    Header,
    Popup
} from "semantic-ui-react";
import { BulkActionsContext } from "shared/context/BulkActionsProvider";
import { PhoneUtil } from 'utils';
import { USER_PERMISSIONS } from 'dyl-components';
import RestrictedView from 'shared/RestrictedView';


const Row = ({ extension, typeCounts, onReadCompanyExtension, onRemove }) => {
    const [selectedExtensions, setSelectedExtensions] =
        useContext(BulkActionsContext);
    const [isVoicemailPlaybackOpen, setIsVoicemailPlaybackOpen] = useState(false);

    const isSelected = (extension_id) => {
        return selectedExtensions.includes(extension_id);
    };

    const onToggleExtension = (extension_id) => {
        const newSelectedExtensions = isSelected(extension_id)
            ? selectedExtensions.filter((id) => extension_id !== id)
            : [...selectedExtensions, extension_id];
        setSelectedExtensions(newSelectedExtensions);
    };

    const getTextFromKey = (key) => {
        const extension = PhoneUtil.COMPANY_EXTENSION_TYPES.find(ext => ext.key === key);
        return extension ? extension.text : null;
    }
    
    const inUse = (((extension?.type === 'conference_room' || extension?.type === 'parking_lot') && typeCounts[extension?.type] <= 1) || extension.in_use);

    return (
        <Table.Row>
            <Table.Cell>
                <Checkbox
                    checked={isSelected(extension.id)}
                    onChange={() => {
                        onToggleExtension(extension.id);
                    }}
                    disabled
                />
            </Table.Cell>
            <Table.Cell>{extension.extension}</Table.Cell>
            <Table.Cell>{getTextFromKey(extension.type)}</Table.Cell>
            <Table.Cell>{extension.label}</Table.Cell>
            <Table.Cell>{extension.display_view ? "on" : "off"}</Table.Cell>
            <Table.Cell>{extension.pin}</Table.Cell>
            <Table.Cell>
            <Popup
                    style={{minWidth:400}}
                    trigger={
                        <Icon className="fa-solid fa-music" size="large" disabled={!!!extension?.audio?.url} /> 
                    }
                    on="click"
                    content={
                        <VoicemailPlayback
                            onClose={() => setIsVoicemailPlaybackOpen(false)}
                            className={`audio-playback-${extension.id}`}
                            fileName={extension?.audio?.label}
                            link={extension?.audio?.url}
                        />
                    }
                    position="bottom center"
                    open={isVoicemailPlaybackOpen}
                    onOpen={() => setIsVoicemailPlaybackOpen(true)}
                />
            </Table.Cell>
            <Table.Cell>
                <EllipsisDropdown>
                    <RestrictedView type='disabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_EDIT}>
                        <DropdownItem
                            style={{ cursor: "pointer" }}
                            text="Edit"
                            icon="fas fa-edit"
                            onClick={() => onReadCompanyExtension(extension.id, extension.type)}
                        />
                    </RestrictedView>
                    <RestrictedView type='controlledPopupDisabled' userPermission={USER_PERMISSIONS.PHONE_MANAGEMENT_DELETE}>
                        <ControlledPopup
                            header={
                                <Header as="h4" textAlign="center">
                                    Are you sure?
                                </Header>
                            }
                            trigger={
                                !!inUse ? (
                                    <Popup
                                        content={`${getTextFromKey(extension.type)} in use`}
                                        position="right center"
                                        inverted
                                        on={'hover'}
                                        trigger={
                                            <Dropdown.Item 
                                                className={`company-voicemail-${
                                                    !!inUse ? "disable" : ""
                                                }`} 
                                                icon={'fas fa-trash-alt'} 
                                                text={"Delete"} 
                                            />
                                        }
                                    />
                                ) : (
                                    <Dropdown.Item
                                        text="Delete"
                                        icon="fa-solid fa-trash"
                                    />
                                )
                            }
                            onConfirm={() => onRemove(extension.id, extension.type)}
                            inverted
                        />
                    </RestrictedView>
                </EllipsisDropdown>
            </Table.Cell>
        </Table.Row>
    );
};

export default Row;
